/**
 * @generated SignedSource<<c0a9051cebd1eac257fdfaf8c591cd27>>
 * @relayHash 27e3cb1bafa5601d0b04887008235841
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 27e3cb1bafa5601d0b04887008235841

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "action"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "action",
        "variableName": "action"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "StatusResponse",
    "kind": "LinkedField",
    "name": "accountUpdateStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountUpdateStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountUpdateStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "27e3cb1bafa5601d0b04887008235841",
    "metadata": {},
    "name": "AccountUpdateStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "a655d389f2e62cfaad2edf9ec50dc150";

export default node;
